import { Typography, Input } from '@material-tailwind/react'
import PropTypes from 'prop-types'

export const AccessField = ({
  documento,
  handleChange,
  handleBlur,
  handleClear,
  gunMode,
  scanArmed
}) => {
  const blockIfGun = (e) => {
    if (!gunMode) return
    if (e.type === 'keydown' && e.key === 'Tab') return
    e.preventDefault()
    e.stopPropagation()
  }

  const inputClasses = [
    '!border pr-10',
    gunMode ? 'bg-gray-100 cursor-not-allowed' : '',
    scanArmed ? '!border-red-600 ring-1 ring-red-300' : 'focus:!border-blue-500'
  ].join(' ')

  const inputTitle = scanArmed
    ? 'Ventana activa: preparado para escanear (borde rojo)'
    : gunMode
      ? 'Modo pistola activo: entrada manual bloqueada'
      : undefined

  return (
    <div>
      <Typography variant="small" color="blue-gray" className="mb-1">
        Documento de Identidad o Número de Patente
      </Typography>
      <div className="relative">
        <Input
          id="documento-input"
          size="lg"
          placeholder="Ej: 12.345.678-9 o BCDF1234"
          value={documento}
          readOnly={gunMode}
          aria-readonly={gunMode}
          onBlur={handleBlur}
          onChange={(e) => {
            if (gunMode) return
            handleChange(e)
          }}
          onKeyDown={blockIfGun}
          onBeforeInput={blockIfGun}
          onPaste={blockIfGun}
          className={inputClasses}
          labelProps={{ className: 'hidden' }}
          title={inputTitle}
        />
        {documento && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute inset-y-0 right-3 flex items-center"
            disabled={gunMode}
            title={gunMode ? 'Modo pistola activo: no se puede limpiar' : 'Borrar'}
          >
            <svg className={`h-5 w-5 ${gunMode ? 'text-gray-300' : 'text-gray-400 hover:text-gray-600'}`} viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
            </svg>
          </button>
        )}
      </div>
    </div>
  )
}

AccessField.propTypes = {
  documento: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired,
  gunMode: PropTypes.bool.isRequired,
  scanArmed: PropTypes.bool.isRequired
}
